"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedTextArea = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)({
    wrapper: {
        lineHeight: '1.1876em',
        fontWeight: 500,
        padding: '2pt',
        marginBottom: 1,
        whiteSpace: 'break-spaces',
        overflowY: 'auto',
    },
});
function HighlightedTextArea({ fontSize, minRows, maxRows, highlightedContent, }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { style: {
            fontSize,
            minHeight: minRows * 18,
            maxHeight: maxRows * 18,
        }, className: classes.wrapper }, highlightedContent));
}
exports.HighlightedTextArea = HighlightedTextArea;
//# sourceMappingURL=highlighted-text-area.js.map